import { ApolloClient } from '@apollo/client';
import {
  NodeUrvalQuery as INodeUrvalQueryData,
  NodeUrvalQueryVariables as INodeUrvalQueryVariables,
} from './_QueryTypes/NodeUrvalQuery';
import { NodeUrvalType } from '../../../../../../Types/UrvalTypes';
import query from './NodeUrvalQuery.gql';

/**
 * Manually fires a selection node query
 */
export const queryNodeUrval = (
  apolloClient: ApolloClient<any>,
  id: string
): Promise<NodeUrvalType> => {
  const variables: INodeUrvalQueryVariables = { id };

  return apolloClient
    .query<INodeUrvalQueryData, INodeUrvalQueryVariables>({
      query,
      variables,
    })
    .then(({ errors, data }) => {
      if (data && data.node && data.node.__typename === 'TEDSelection') {
        return Promise.resolve(data.node);
      } else {
        if (errors) {
          return Promise.reject(errors);
        }
        return Promise.reject(new Error('Got no node'));
      }
    });
};
